import { Component } from '@angular/core';

@Component({
  selector: 'pes-messages',
  templateUrl: './messages.component.html',
})
export class PesMessagesComponent {
  constructor() {}
}
